import React, { FC } from "react";

import { useTranslation } from "react-i18next";
import { useMount } from "react-use";
import { Hidden } from "@mui/material";

import { StandardLayout } from "@/components/layouts";
import config from "@/config";
import { aboutApi } from "@/shared/apis";
import { useAuth } from "@/shared/hooks";
import { useUserFeedback } from "@/userFeedback";

import {
    StyledAbout,
    StyledBodyTitle,
    StyledDetails,
    StyledDetailsContainer,
    StyledInfo,
    StyledInfoBody,
    StyledInfoBodyDetails,
    StyledInfoBodyTitle,
    StyledInfoTitle,
} from "./styled";

const AboutPage: FC = () => {
    const { t } = useTranslation();
    const { incUsageCount } = useUserFeedback();

    useMount(incUsageCount);
    const { user } = useAuth();
    const about = aboutApi.useQueryAbout();

    return (
        <StandardLayout title={t("PageTitles.UserSetting")}>
            <StyledAbout data-testid="userSettings-about">
                <Hidden smUp>
                    <div>
                        <StyledBodyTitle>{t("Settings.Steps.About")}</StyledBodyTitle>
                    </div>
                </Hidden>
                <StyledInfoBodyTitle>{t("Settings.About.Info")}</StyledInfoBodyTitle>
                <StyledInfo>
                    <StyledInfoTitle>{t("Settings.About.ProfileInfo")}</StyledInfoTitle>
                    <StyledDetailsContainer>
                        <StyledDetails>
                            <StyledInfoBody>{t("Common.Email")}</StyledInfoBody>
                            <StyledInfoBodyDetails>{user.email}</StyledInfoBodyDetails>
                        </StyledDetails>
                        <StyledDetails>
                            <StyledInfoBody>{t("Settings.About.UserInfo.OfficeID")}</StyledInfoBody>
                            <StyledInfoBodyDetails>{user.currentBrokerId}</StyledInfoBodyDetails>
                        </StyledDetails>
                        <StyledDetails>
                            <StyledInfoBody>{t("Settings.About.UserInfo.Id")}</StyledInfoBody>
                            <StyledInfoBodyDetails>{user.id}</StyledInfoBodyDetails>
                        </StyledDetails>
                    </StyledDetailsContainer>
                </StyledInfo>
                <StyledInfo>
                    <StyledInfoTitle>{t("Settings.About.SoftwareInfo")}</StyledInfoTitle>
                    <StyledDetailsContainer>
                        <StyledDetails>
                            <StyledInfoBody>{t("Settings.About.SoftInfo.Project")}</StyledInfoBody>
                            <StyledInfoBodyDetails>MyBroker</StyledInfoBodyDetails>
                        </StyledDetails>
                        <StyledDetails>
                            <StyledInfoBody>{t("Settings.About.SoftInfo.Version")}</StyledInfoBody>
                            <StyledInfoBodyDetails>
                                {about.version || "-"} ({about.releaseDate})
                            </StyledInfoBodyDetails>
                        </StyledDetails>
                        <StyledDetails>
                            <StyledInfoBody>{t("Settings.About.SoftInfo.AppVersion")}</StyledInfoBody>
                            <StyledInfoBodyDetails>
                                {config.BUILD.VERSION} ({config.BUILD.BUILD_DATE})
                            </StyledInfoBodyDetails>
                        </StyledDetails>
                    </StyledDetailsContainer>
                </StyledInfo>
            </StyledAbout>
        </StandardLayout>
    );
};

export default AboutPage;
